import z from "zod";

const twilioErrorTypeValues = [
  "SMS_MESSAGE_FAILURE",
  "SMS_RECEIVE_PARSE_FAILED",
  "PHONE_LOOKUP_PARSE_FAILED",
  "PHONE_AREA_CODE_LOOKUP_FAILED",
  "NOT_IMPLEMENTED_BY_TWILIO",
] as const;

const twilioErrorTypeSchema = z.enum(twilioErrorTypeValues);
const TwilioErrorType = twilioErrorTypeSchema.enum;
type TwilioErrorType = z.infer<typeof twilioErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type TwilioErrors =
  | {
      errorType: typeof TwilioErrorType.SMS_MESSAGE_FAILURE;
      data: {
        to: string;
        from: string;
        errorCode: number;
        twilioSid?: string;
      };
    }
  | {
      errorType: typeof TwilioErrorType.SMS_RECEIVE_PARSE_FAILED;
      data: {
        smsResponse: unknown;
        parseError?: string;
      };
    }
  | {
      errorType: typeof TwilioErrorType.PHONE_LOOKUP_PARSE_FAILED;
      data: {
        phoneNumber: string;
        lookupData: unknown;
        parseError?: string;
      };
    }
  | {
      errorType: typeof TwilioErrorType.PHONE_AREA_CODE_LOOKUP_FAILED;
      data: {
        areaCode?: string;
      };
    }
  | {
      errorType: typeof TwilioErrorType.NOT_IMPLEMENTED_BY_TWILIO;
      data: {
        operation: string;
      };
    };

export const twilioErrorDetails: Record<TwilioErrorType, ErrorDetails> = {
  [TwilioErrorType.SMS_MESSAGE_FAILURE]: {
    sentryDescription: "General message failure in Twilio SMS",
  },
  [TwilioErrorType.SMS_RECEIVE_PARSE_FAILED]: {
    sentryDescription: "Failed to parse Twilio SMS webhook data",
  },
  [TwilioErrorType.PHONE_LOOKUP_PARSE_FAILED]: {
    sentryDescription: "Failed to parse Twilio phone lookup response",
  },
  [TwilioErrorType.PHONE_AREA_CODE_LOOKUP_FAILED]: {
    sentryDescription: "Failed to lookup phone number via area code",
  },
  [TwilioErrorType.NOT_IMPLEMENTED_BY_TWILIO]: {
    sentryDescription: "Not implemented by Twilio",
  },
};
